import {useNavigate, useSearchParams} from "react-router-dom";
import {containerClusterSelector, useGetContainerClusterQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {ContainerClusterProfile} from "../../components/profile/ContainerClusterProfile/ContainerClusterProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const ContainerClusterProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.containercluster", "Container Cluster") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <ContainerClusterProfilePage id={id}/>;
};

export const ContainerClusterProfilePage = (props: Props) => {
  const {id} = props;

  const selectContainerCluster = useMemo(() => {
    return containerClusterSelector()
  }, []);

  const {containerCluster, isFetching} = useGetContainerClusterQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      containerCluster: selectContainerCluster(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage entity={containerCluster} isLoading={isFetching} permissions={["view", "containerCluster_view"]}>
      {(entity) => (
        <ContainerClusterProfile containerCluster={entity}/>
      )}
    </EntityProfilePage>
  )
};
